import { Button } from 'primereact/button';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import Moment from 'react-moment';
import 'moment/locale/fr';
import React, { useRef ,useState, useEffect } from "react";
import {
    Outlet,
    useLoaderData,
    Form,
    redirect
} from "react-router-dom";
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import { Checkbox } from 'primereact/checkbox';

import { getRental, next, authorizePayment, hub, skipPayment, updateRemainingToBePaid, addAdvancedPayment, sendDepositLink, sendAdvancePaymentReminder, regenDepositLink, updateRental, updateSignNowSignature, resendSignNowSignature, sendElectronicSignatureReminder, closeRentalNow, clientCancellation, getUnpaidAdvanceClosureEmail, closeUnpaidAdvanceRental, getLessorCancellationEmail, deleteRentalStep, downloadFullContract, printDeliveryReceipt, getFullContractPreviewUrl } from "../../../data/loca/rentals";
import { getAccount } from "../../../data/accounts";
import { IsNullOrEmpty } from "../../../services/CustomService";
import { getCurrentUser } from "../../../data/auth.service";
import {
    HubConnectionBuilder,
    HubConnectionState
} from '@microsoft/signalr';

import { Dialog } from 'primereact/dialog';
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { calendarStrings } from '../../../services/calendarStrings';
import { send, notify } from "../../../services/NotificationService";
import { capture, getStripeDepositLogs } from "../../../data/loca/deposits";
import RentalSatisfactionPanel from "./satisfaction-panel";
import { RentalDeliveryVehicleNotice } from "./DeliveryVehicleNotice";

export async function loader({ params }) {
    const rental = await getRental(params.rentalId);

    if (rental.status === "Draft") {
        return redirect(`/${params.rentalId}/modifier`);
    }  
    const acc = await getAccount();
    return { rental, acc };
}

// Trajet simple memorise par l'outil d'estimation des frais de livraison.
const formatTripDistance = (meters) => {
    const value = Number(meters) || 0;
    return value >= 1000
        ? `${(value / 1000).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} km`
        : `${value} m`;
};

const formatTripDuration = (seconds) => {
    const minutes = Math.ceil((Number(seconds) || 0) / 60);
    if (minutes < 60) {
        return `${minutes} min`;
    }
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return rest ? `${hours} h ${String(rest).padStart(2, "0")}` : `${hours} h`;
};

export default function Rental() {
    const { rental, acc } = useLoaderData();

    const menuLeft = useRef(null);
    const toast = useRef(null);

    const [status, setStatus] = useState(rental.status);
    const [nextstep, setNextstep] = useState(rental.nextStep);
    const [visible, setVisible] = useState(false);
    const [captureFees, setCaptureFees] = useState([{ description: '', amount: '' }]);
    const [isCapturingDeposit, setIsCapturingDeposit] = useState(false);
    const [stepsVisible, setStepsVisible] = useState(false);
    const [paymentfeesvisible, setPaymentfeesvisible] = useState(false);
    const [remainingToBePaidCentsVisible, setRemainingToBePaidCentsVisible] = useState(false);
    const [isNextStepLoading, setIsNextStepLoading] = useState(false);
    const [deletingStep, setDeletingStep] = useState(null);
    const [nextsteps, setNextsteps] = useState(rental.nextSteps || []);
    const [isManualAdvanceLoading, setIsManualAdvanceLoading] = useState(false);
    const [sendManualAdvancePaymentEmail, setSendManualAdvancePaymentEmail] = useState(false);
    const [isAdvancePaymentReminderLoading, setIsAdvancePaymentReminderLoading] = useState(false);
    const [unpaidAdvanceClosureVisible, setUnpaidAdvanceClosureVisible] = useState(false);
    const [sendUnpaidAdvanceClosureEmail, setSendUnpaidAdvanceClosureEmail] = useState(true);
    const [unpaidAdvanceClosureEmail, setUnpaidAdvanceClosureEmail] = useState(null);
    const [isUnpaidAdvanceClosureEmailLoading, setIsUnpaidAdvanceClosureEmailLoading] = useState(false);
    const [isUnpaidAdvanceClosureLoading, setIsUnpaidAdvanceClosureLoading] = useState(false);
    const [cancelRentalVisible, setCancelRentalVisible] = useState(false);
    const [sendCancellationEmail, setSendCancellationEmail] = useState(false);
    const [cancellationReason, setCancellationReason] = useState("");
    const [cancellationEmail, setCancellationEmail] = useState(null);
    const [isCancellationEmailLoading, setIsCancellationEmailLoading] = useState(false);
    const [isCancelRentalLoading, setIsCancelRentalLoading] = useState(false);
    const [signNowUpdating, setSignNowUpdating] = useState(false);
    const [isElectronicSignatureReminderLoading, setIsElectronicSignatureReminderLoading] = useState(false);
    const [isFullContractDownloading, setIsFullContractDownloading] = useState(false);
    const [isDeliveryReceiptPrinting, setIsDeliveryReceiptPrinting] = useState(false);
    const [showContractPreview, setShowContractPreview] = useState(false);
    const [loadingContractPreview, setLoadingContractPreview] = useState(false);
    const [contractPreviewUrl, setContractPreviewUrl] = useState("");
    const [stripeDepositLogsVisible, setStripeDepositLogsVisible] = useState(false);
    const [isStripeDepositLogsLoading, setIsStripeDepositLogsLoading] = useState(false);
    const [stripeDepositLogs, setStripeDepositLogs] = useState(null);
    const boardId = getCurrentUser().publicId + "/" + rental.rentalPublicId;;

    const load = () => {
        
    };
    const setUpSignalRPublicApiConnection = async (boardId: string) => {

        var hubLink = await hub();

        const publicApiconnection = new HubConnectionBuilder()
            .withUrl(hubLink + 'lokappdhub') // publicAPI
            .withAutomaticReconnect()
            .build();

        publicApiconnection.on('RentalUpdated', (s) => {

            var r = getRental(s.id);


        });

        try {
            await publicApiconnection.start();
        } catch (err) {
            console.log(err);
        }

        if (publicApiconnection.state === HubConnectionState.Connected) {
            publicApiconnection.invoke('SubscribeToRental', boardId).catch((err: Error) => {
                return console.error(err.toString());
            });
        }

        return publicApiconnection;
    };
    useEffect(() => {
        setStatus(rental.status);
        setNextstep(rental.nextStep);
        setNextsteps(rental.nextSteps || []);
    }, [rental.rentalPublicId, rental.status, rental.nextStep, rental.nextSteps]);

    useEffect(() => {
        setVisible(false);
        setCaptureFees([{ description: '', amount: '' }]);
        setIsCapturingDeposit(false);
        setStepsVisible(false);
        setPaymentfeesvisible(false);
        setRemainingToBePaidCentsVisible(false);
        setIsNextStepLoading(false);
        setDeletingStep(null);
        setIsManualAdvanceLoading(false);
        setSendManualAdvancePaymentEmail(false);
        setIsAdvancePaymentReminderLoading(false);
        setSignNowUpdating(false);
        setIsElectronicSignatureReminderLoading(false);
        setIsFullContractDownloading(false);
        setIsDeliveryReceiptPrinting(false);
        setShowContractPreview(false);
        setLoadingContractPreview(false);
        setContractPreviewUrl("");
        setStripeDepositLogsVisible(false);
        setIsStripeDepositLogsLoading(false);
        setStripeDepositLogs(null);
    }, [rental.rentalPublicId]);

    useEffect(() => {
        if (!window.matchMedia("(max-width: 760px)").matches) {
            return;
        }

        const frameId = window.requestAnimationFrame(() => {
            const rentalDetail = document.getElementById("thumbnail");
            if (!rentalDetail) {
                window.scrollTo({ top: 0, behavior: "auto" });
                return;
            }

            const top = rentalDetail.getBoundingClientRect().top + window.scrollY - 8;
            window.scrollTo({ top: Math.max(0, top), behavior: "auto" });
        });

        return () => window.cancelAnimationFrame(frameId);
    }, [rental.rentalPublicId]);

    useEffect(() => {
        let connection = null;
        let isDisposed = false;

        setUpSignalRPublicApiConnection(boardId).then((con) => {
            if (isDisposed) {
                con?.stop();
                return;
            }

            connection = con;
        });

        return () => {
            isDisposed = true;
            connection?.stop();
        };
    }, [boardId]);

    useEffect(() => {
        return () => {
            if (contractPreviewUrl) {
                window.URL.revokeObjectURL(contractPreviewUrl);
            }
        };
    }, [contractPreviewUrl]);

    if (rental.status === 500) {
        send("error", rental.message)

        return (<center>Une erreur est survenue lors de la récupération de la location !</center>);
    }
    
    var needMessage = (IsNullOrEmpty(acc.address) || IsNullOrEmpty(acc.city) || IsNullOrEmpty(acc.zipcode) || IsNullOrEmpty(acc.phone))
    const canSendDepositMail = status === "Confirmed";
    const depositMailNotAllowedMessage = "La location doit être validée avant d'envoyer le mail de caution.";

    const sendDepositLinkAction = () => {
        if (!canSendDepositMail) {
            send("warning", depositMailNotAllowedMessage);
            return;
        }
        var ret = sendDepositLink(rental.rentalPublicId);
        ret.then((a) => {
            if (a.status === 200) {
                send("success", a.message)
            } else if (a.status === 400) {
                send("warning", a.message)
            } else {
                send("error", a.message)
            }
            notify();
        });
    };
    const regenDepositLinkAction = () => {
        if (!canSendDepositMail) {
            send("warning", depositMailNotAllowedMessage);
            return;
        }
        var ret = regenDepositLink(rental.rentalPublicId);
        ret.then((a) => {
            if (a.status === 200) {
                send("success", a.message)
            } else if (a.status === 400) {
                send("warning", a.message)
            } else {
                send("error", a.message)
            }
            notify();
        });
    };
    
    const authorizeStripePayment = () => {


        if (acc.stripeStatus !== "AccountCreated") {
            send("warning", "Votre compte Stripe n'est pas configuré pour recevoir des paiements ! Rendez vous sur votre compte pour commencer !")
            notify();
        } else {
            var feesAmount = document.getElementById('paymentFeesAmount').value;
            let a = authorizePayment(rental.rentalPublicId, feesAmount);
            a.then((a) => {
                send("success", "Votre client peut se rendre sur sa page de location pour effectuer le paiement ! Un mail lui a été envoyé !")
                window.location.reload();
            });
        }
    };
    const remainingToBePaidAction = () => {

        var feesAmount = document.getElementById('remainingToBePaid').value;

        var ret = updateRemainingToBePaid(rental.rentalPublicId, feesAmount);
        ret.then((a) => {
            if (a.status === 200) {
                send("success", a.message)
                window.location.reload();
            } else if (a.status === 400) {
                send("warning", a.message)
            } else {
                send("error", a.message)
            }
            notify();
        });
        notify();

    };
    const addAdvancedPaymentAction = () => {

        var manualAdvancedPayment = document.getElementById('advancedPayment').value;
        addAdvancedPaymentAmount(manualAdvancedPayment, sendManualAdvancePaymentEmail);
    };
    const addAdvancedPaymentAmount = (amount, sendEmail = false) => {
        setIsManualAdvanceLoading(true);
        var ret = addAdvancedPayment(rental.rentalPublicId, amount, sendEmail);
        ret.then((a) => {
            if (a.status === 200) {
                send("success", a.message)
                if (a.rentalNextStep !== undefined) {
                    setNextstep(a.rentalNextStep);
                }
                if (a.rentalStatus) {
                    setStatus(a.rentalStatus);
                }
                window.location.reload();
            } else if (a.status === 400) {
                send("warning", a.message)
            } else {
                send("error", a.message)
            }
            notify();
        }).finally(() => {
            setIsManualAdvanceLoading(false);
        });
        notify();

    };
    const sendAdvancePaymentReminderAction = () => {
        setIsAdvancePaymentReminderLoading(true);
        sendAdvancePaymentReminder(rental.rentalPublicId).then((a) => {
            if (a.status === 200) {
                send("success", a.message)
                window.location.reload();
            } else if (a.status === 400) {
                send("warning", a.message)
            } else {
                send("error", a.message)
            }
            notify();
        }).finally(() => {
            setIsAdvancePaymentReminderLoading(false);
        });
    };
    const openUnpaidAdvanceClosure = () => {
        setSendUnpaidAdvanceClosureEmail(true);
        setUnpaidAdvanceClosureEmail(null);
        setUnpaidAdvanceClosureVisible(true);
        setIsUnpaidAdvanceClosureEmailLoading(true);
        getUnpaidAdvanceClosureEmail(rental.rentalPublicId).then((a) => {
            if (a?.status === 200) {
                setUnpaidAdvanceClosureEmail(a);
            }
        }).catch(() => {
        }).finally(() => {
            setIsUnpaidAdvanceClosureEmailLoading(false);
        });
    };
    const closeUnpaidAdvanceRentalAction = () => {
        setIsUnpaidAdvanceClosureLoading(true);
        closeUnpaidAdvanceRental(rental.rentalPublicId, sendUnpaidAdvanceClosureEmail).then((a) => {
            if (a.status === 200) {
                send(a.emailSent === false ? "warning" : "success", a.message)
                window.location.reload();
            } else if (a.status === 400) {
                send("warning", a.message)
            } else {
                send("error", a.message)
            }
            notify();
        }).finally(() => {
            setIsUnpaidAdvanceClosureLoading(false);
        });
    };

    //
    const authorizePopup = () => {


        if (acc.stripeStatus !== "AccountCreated") {
            send("warning", "Votre compte Stripe n'est pas configuré pour recevoir des paiements ! Rendez vous sur votre compte pour commencer !")
            notify();
        } else {
            setPaymentfeesvisible(true);
        }
    };


    const updateCaptureFee = (index, field, value) => {
        setCaptureFees(fees => fees.map((fee, feeIndex) => feeIndex === index ? { ...fee, [field]: value } : fee));
    };

    const parseAmountCents = (amount) => {
        const normalizedAmount = String(amount || '').trim().replace(',', '.');
        const parsedAmount = Number(normalizedAmount);
        return Number.isFinite(parsedAmount) ? Math.round(parsedAmount * 100) : 0;
    };

    const validCaptureFees = captureFees
        .map(fee => ({ description: fee.description.trim(), amountCents: parseAmountCents(fee.amount) }))
        .filter(fee => fee.description && fee.amountCents > 0);
    const captureTotalCents = validCaptureFees.reduce((total, fee) => total + fee.amountCents, 0);

    const capturedeposit = () => {
        if (!validCaptureFees.length) {
            send("warning", "Ajoutez au moins un frais avec un montant positif.");
            notify();
            return;
        }

        setIsCapturingDeposit(true);
        capture(rental.rentalPublicId, validCaptureFees)
            .then(() => {
                send("success", "Caution partiellement libérée.");
                window.location.reload();
            })
            .catch((error) => {
                send("error", error?.message || "La caution n'a pas pu être récupérée.");
                notify();
            })
            .finally(() => setIsCapturingDeposit(false));
    };
    const loadStripeDepositLogsAction = () => {
        setStripeDepositLogsVisible(true);
        setIsStripeDepositLogsLoading(true);
        getStripeDepositLogs(rental.rentalPublicId)
            .then((data) => {
                if (!data) {
                    send("warning", "Aucun log Stripe n'a été trouvé pour cette caution.");
                    return;
                }

                setStripeDepositLogs(data);
            })
            .catch((error) => {
                send("error", error?.message || "Impossible de récupérer les logs Stripe de la caution.");
            })
            .finally(() => {
                setIsStripeDepositLogsLoading(false);
                notify();
            });
    };
    const updateSignNowSignatureAction = (signed) => {
        setSignNowUpdating(true);
        updateSignNowSignature(rental.rentalPublicId, signed).then((a) => {
            if (a.status === 200) {
                send("success", a.message);
                window.location.reload();
            } else if (a.status === 400) {
                send("warning", a.message);
            } else {
                send("error", a.message);
            }
            notify();
        }).finally(() => setSignNowUpdating(false));
    };
    const resendSignNowSignatureAction = () => {
        setSignNowUpdating(true);
        resendSignNowSignature(rental.rentalPublicId).then((a) => {
            if (a.status === 200) {
                send("success", a.message);
                window.location.reload();
            } else if (a.status === 400) {
                send("warning", a.message);
            } else {
                send("error", a.message);
            }
            notify();
        }).finally(() => setSignNowUpdating(false));
    };
    const sendElectronicSignatureReminderAction = () => {
        setIsElectronicSignatureReminderLoading(true);
        sendElectronicSignatureReminder(rental.rentalPublicId).then((a) => {
            if (a.status === 200) {
                send("success", a.message);
                window.location.reload();
            } else if (a.status === 400) {
                send("warning", a.message);
            } else {
                send("error", a.message);
            }
            notify();
        }).finally(() => setIsElectronicSignatureReminderLoading(false));
    };
    const downloadFullContractAction = () => {
        setIsFullContractDownloading(true);
        downloadFullContract(rental.rentalPublicId).catch(() => {
            send("error", "Impossible de télécharger le contrat complet.");
            notify();
        }).finally(() => {
            setIsFullContractDownloading(false);
        });
    };
    const showContractPreviewAction = async () => {
        setLoadingContractPreview(true);
        try {
            const previewUrl = await getFullContractPreviewUrl(rental.rentalPublicId);
            if (!previewUrl) {
                setLoadingContractPreview(false);
                return;
            }
            setContractPreviewUrl((previousUrl) => {
                if (previousUrl) {
                    window.URL.revokeObjectURL(previousUrl);
                }
                return previewUrl;
            });
            setShowContractPreview(true);
        } catch (error) {
            send("error", "Impossible de charger l'aperçu du contrat.");
            notify();
            setLoadingContractPreview(false);
        }
    };
    const printDeliveryReceiptAction = () => {
        setIsDeliveryReceiptPrinting(true);
        printDeliveryReceipt(rental.rentalPublicId).catch(() => {
            send("error", "Impossible de générer le bon de livraison.");
            notify();
        }).finally(() => {
            setIsDeliveryReceiptPrinting(false);
        });
    };
    const copyRentalAddress = async () => {
        const address = rental.deliveryAddress || rental.clientAddress;
        if (IsNullOrEmpty(address)) {
            send("warning", "Aucune adresse à copier.");
            notify();
            return;
        }

        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(address);
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = address;
                textArea.setAttribute("readonly", "");
                textArea.style.position = "fixed";
                textArea.style.opacity = "0";
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
            }
            send("success", "Adresse copiée");
        } catch {
            send("warning", "Impossible de copier automatiquement.");
        }
        notify();
    };
    const acceptmail = () => {
        setIsNextStepLoading(true);
        var ret = next(rental.rentalPublicId);
        ret.then(async (a) => {
            if (a.status === 200) {
                //setNextstep(a.rentalNextStep);

                send("success", a.message)
                // rechargement de la page
                window.location.reload();
            }
        }).finally(() => {
            setIsNextStepLoading(false);
        });
    };

    const acceptNextStep = () => {
        setIsNextStepLoading(true);
        var ret = next(rental.rentalPublicId, "true");
        ret.then((a) => {
            if (a.status === 200) {
                //setNextstep(a.rentalNextStep);
                send("success", a.message)
                window.location.reload();
            } else if (a.status === 400) {
                send("warning", a.message)
                window.location.reload();

            } else {
                send("error", a.message)
                window.location.reload();

            }
        }).finally(() => {
            setIsNextStepLoading(false);
        });
    };

    const reject = () => {
    };
    
    const deleteLocation = () => {
        setSendCancellationEmail(false);
        setCancellationReason("");
        setCancelRentalVisible(true);
    };
    const toggleCancellationEmail = (checked) => {
        setSendCancellationEmail(checked);
        if (!checked || cancellationEmail || isCancellationEmailLoading) {
            return;
        }
        setIsCancellationEmailLoading(true);
        getLessorCancellationEmail(rental.rentalPublicId).then((a) => {
            if (a?.status === 200) {
                setCancellationEmail(a);
            }
        }).catch(() => {
        }).finally(() => {
            setIsCancellationEmailLoading(false);
        });
    };
    const cancelRentalAction = () => {
        setIsCancelRentalLoading(true);
        const cancellationEmailRequest = sendCancellationEmail ? { reason: cancellationReason.trim() } : null;
        updateRental(rental.rentalPublicId, 'Cancelled', cancellationEmailRequest).then((a) => {
            if (a?.status === 400 || a?.status === 500) {
                send(a.status === 400 ? "warning" : "error", a.message);
                notify();
                return;
            }
            // Sans mail, l'API renvoie un simple texte : seul l'envoi du mail produit un message à afficher.
            send(a?.emailSent === false ? "warning" : "success", a?.message ?? "La location a bien été supprimée !");
            window.location.reload();
        }).finally(() => {
            setIsCancelRentalLoading(false);
        });
    };

    const removeRentalStep = (step, event) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Supprimer cette étape de la location ?',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Supprimer',
            rejectLabel: 'Annuler',
            accept: () => {
                setDeletingStep(step);
                deleteRentalStep(rental.rentalPublicId, step).then((a) => {
                    if (a.status === 200) {
                        send("success", a.message);
                        setNextstep(a.rentalNextStep);
                        setNextsteps(a.rentalSteps || []);
                        if (a.rentalStatus) {
                            setStatus(a.rentalStatus);
                        }
                        if (!a.rentalSteps || a.rentalSteps.length === 0) {
                            setStepsVisible(false);
                        }
                    } else if (a.status === 400) {
                        send("warning", a.message);
                    } else {
                        send("error", a.message);
                    }
                    notify();
                }).finally(() => {
                    setDeletingStep(null);
                });
            },
            reject
        });
    };

    const reopenLocation = () => {
        var ret = updateRental(rental.rentalPublicId, 'New');
        ret.then((response) => {
            // Refus si le matériel a été réservé entre-temps par une autre location.
            if (response?.status === 400 || response?.status === 500) {
                send(response.status === 400 ? "warning" : "error", response.message);
                notify();
                return;
            }
            setStatus("New");
            window.location.reload();
        });
    };


    const skipPaymentAction = () => {
        var resp = skipPayment(rental.rentalPublicId);
        resp.then((m) => {
            send("success", m)
            window.location.reload();

        });
    };
    const closeRentalNowAction = (event) => {
        const target = event?.originalEvent?.currentTarget || event?.currentTarget || document.body;
        confirmPopup({
            target: target,
            message: 'Cette action va terminer la location immédiatement et supprimer toutes les étapes futures. Continuer ?',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Oui',
            rejectLabel: 'Non',
            accept: () => {
                closeRentalNow(rental.rentalPublicId).then((a) => {
                    if (a.status === 200) {
                        send("success", a.message);
                    } else if (a.status === 400) {
                        send("warning", a.message);
                    } else {
                        send("error", a.message);
                    }
                    notify();
                    window.location.reload();
                });
            },
            reject
        });
    };
    
    const goToNextStep = (event) => {
        
        if (nextstep === "SendContractNeeded") {
            var message = 'Attention, cette action enverra un mail à votre locataire (' + rental.clientEmail + '). Êtes-vous sûr ?'
            if (needMessage) {
                message = 'Certains éléments qui vous concernent sont manquants. Êtes-vous sûr de vouloir envoyer ce contrat à votre locataire ? '
            }
            confirmPopup({
                target: event.currentTarget,
                message: message,
                icon: 'pi pi-info-circle',
                defaultFocus: 'reject',
                acceptClassName: 'p-button-danger',
                acceptLabel: 'Oui',
                rejectLabel: 'Non',
                accept: () => { acceptmail(); },
                reject
            });
        } else if (nextstep === 'ReleaseDepositNeeded') {
            
            var mes = (IsNullOrEmpty(rental.permanentLinkDeposit) ? 'Attention, cette action va libérer la caution. Êtes-vous sûr ?' : 'Confirmez-vous avoir libéré la caution du lien ' + rental.permanentLinkDeposit + ' ?')
            load();
            confirmPopup({
                target: event.currentTarget,
                message: mes,
                icon: 'pi pi-info-circle',
                defaultFocus: 'reject',
                acceptClassName: 'p-button-danger',
                acceptLabel: 'Oui',
                rejectLabel: 'Non',
                accept: () => { acceptNextStep(); },
                reject
            });
        }
        else {
            load();
            setIsNextStepLoading(true);
            var ret = next(rental.rentalPublicId);
            ret.then((a) => {
                if (a.status === 200) {
                    send("success", a.message)
                    window.location.reload();
                } else if (a.status === 400) {
                    send("warning", a.message)
                } else {
                    send("error", a.message)
                }
                
            }).finally(() => {
                setIsNextStepLoading(false);
            });
            
        }
       
    };
   
    const option_deposit = [
        {
            label: 'Options : Caution',
            items: [
                {
                    label: 'Envoyer le lien',
                    icon: 'pi pi-envelope' ,
                    disabled: !canSendDepositMail,
                    command: () => {
                        sendDepositLinkAction()
                    }
                },
                {
                    label: 'Regénérer le lien',
                    icon: 'pi pi-sync',
                    disabled: !canSendDepositMail,
                    command: () => {
                        regenDepositLinkAction()
                    }
                },
                {
                    label: 'Terminer la location',
                    icon: 'pi pi-stop-circle',
                    command: (commandEvent) => {
                        closeRentalNowAction(commandEvent);
                    }
                },
                {
                    label: 'Annulation par le client',
                    icon: 'pi pi-user-minus',
                    command: (commandEvent) => {
                        clientCancellationAction(commandEvent);
                    }
                }
            ]
        }
    ];
    const option_payment = [
        {
            label: 'Options : Paiement',
            items: [
                (!rental.authorizeStripePayment) && {
                    label: 'Autoriser Stripe',
                    icon: 'pi pi-credit-card',
                    command: () => {
                        authorizePopup()
                    }

                },
                (status !== "InProgress") && {
                    label: 'Paiement au retour',
                    icon: 'pi pi-truck',
                    command: () => {
                        skipPaymentAction()
                    }
                },
                {
                    label: 'Terminer la location',
                    icon: 'pi pi-stop-circle',
                    command: (commandEvent) => {
                        closeRentalNowAction(commandEvent);
                    }
                },
                {
                    label: 'Annulation par le client',
                    icon: 'pi pi-user-minus',
                    command: (commandEvent) => {
                        clientCancellationAction(commandEvent);
                    }
                }

            ]
        
                

        }
    ];


    const captureDeposit = () => {
        if (nextstep === "ReleaseDepositNeeded") {
            capturedeposit();
        } 
    };
    const clientCancellationAction = (event) => {
        const target = event?.originalEvent?.currentTarget || event?.currentTarget || document.body;
        confirmPopup({
            target,
            message: "Cette action annule la location à la demande du client. L'acompte déjà encaissé sera conservé dans vos statistiques et un email sera envoyé au client. "
                + (depositRefundNote ? depositRefundNote.text + " " : "")
                + "Continuer ?",
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Confirmer l’annulation',
            rejectLabel: 'Annuler',
            accept: () => {
                clientCancellation(rental.rentalPublicId).then((response) => {
                    if (response.status === 200) {
                        send("success", response.message);
                        window.location.reload();
                    } else if (response.status === 400) {
                        send("warning", response.message);
                    } else {
                        send("error", response.message);
                    }
                    notify();
                });
            },
            reject
        });
    };

    var labelToolRecoveryToConfirmed = "";
    const hasDelivery = rental.delivery === "DeliveryWithPickup"
        || rental.delivery === "DeliveryWithPickupAndSetup"
        || rental.delivery === "DeliveryOnly";
    const merchandiseItems = Array.isArray(rental.merchandiseItems)
        ? rental.merchandiseItems.filter(item => item && item.quantity > 0)
        : [];
    const hasMerchandiseItems = merchandiseItems.length > 0;
    const hasRentalSidePanel = rental.delivery !== "NoDelivery" || hasMerchandiseItems;

    if (rental.delivery === "DeliveryWithPickup")
        labelToolRecoveryToConfirmed = 'Je confirme la livraison';
    else if (rental.delivery === "DeliveryWithPickupAndSetup")
        labelToolRecoveryToConfirmed = 'Je confirme la livraison et la mise en place';
    else if (rental.delivery === "DeliveryOnly")
        labelToolRecoveryToConfirmed = 'Je confirme la livraison';
    else if (rental.delivery === "PickupOnly")
        labelToolRecoveryToConfirmed = 'Je confirme le retrait';
    else labelToolRecoveryToConfirmed= 'Je confirme le retrait';

    const checklistLabels = {
        SendContractNeeded: ['J\'envoie le contrat', 'pi-send'],
        ValidateSignatureNeeded: ['Valider la signature', 'pi-check'],
        DepositMailLinkNeeded: ['J\'envoie le lien de caution', 'pi-send'],
        CBDepositNeeded: ['J\'ai reçu la caution par CB', 'pi-credit-card'],
        CashDepositNeeded: ['J\'ai récupéré la caution en espèces', 'pi-money-bill'],
        CheckDepositNeeded: ['J\'ai récupéré la caution par chèque', 'pi-pencil'],
        BankTransferDepositNeeded: ['Je confirme avoir reçu la caution par virement', 'pi-send'],
        BricolibCodeNeeded: [`J'ai récupéré le code ${rental.serviceName}`, 'pi-lock'],
        ToolRecoveryToConfirmed: [labelToolRecoveryToConfirmed, 'pi-truck'],
        KiwiizCodeNeeded: [`J'ai récupéré le code ${rental.serviceName}`, 'pi-lock'],
        NeedPayment: ['Je confirme avoir reçu le paiement', 'pi-money-bill'],
        ReleaseDepositNeeded: [IsNullOrEmpty(rental.permanentLinkDeposit) ?'Je libère la caution en CB' : 'Je confirme avoir libéré la caution', 'pi-lock-open'],
        ReleaseDepositCashNeeded: ['J\'ai rendu la caution en espèces', 'pi-lock-open'],
        ReleaseDepositBankTransferNeeded: ['Je confirme avoir remboursé la caution par virement', 'pi-send'],
    };
    const getStepLabel = (step) => checklistLabels[step]?.[0] || step;
    const canManageSteps = nextsteps.length > 0;
    let clientLink = `/clients/${rental.clientPublicId}`

    const toolLink = `/monoutil/${rental.toolPublicId}`
    const normalizedSignNowStatus = (rental.signNowSignatureStatus || "").toLowerCase();
    const signNowSigned = Boolean(rental.signNowSignedAt)
        || normalizedSignNowStatus.includes("completed")
        || normalizedSignNowStatus.includes("signed")
        || normalizedSignNowStatus.includes("manual");
    const getSignNowStatusLabel = () => {
        if (!rental.signNowSignatureStatus) return "En attente d'envoi";
        if (normalizedSignNowStatus === "success" || normalizedSignNowStatus === "pending") return "En attente de signature";
        if (normalizedSignNowStatus === "tenant-signed") return "Signé par le locataire";
        if (normalizedSignNowStatus === "owner-invited") return "Signature loueur envoyée";
        if (normalizedSignNowStatus === "owner-signed" || signNowSigned) return "Signé";
        if (normalizedSignNowStatus === "notconfigured") return "SignNow non configuré";
        if (normalizedSignNowStatus === "error") return "Erreur SignNow";
        return rental.signNowSignatureStatus;
    };
    const needsSignNowSignature = rental.signatureRequired;
    const needsElectronicSignatureReminder = needsSignNowSignature
        && !signNowSigned
        && !rental.finalElectronicSignatureReminderSentAt;
    const electronicSignatureReminderLabel = rental.electronicSignatureReminderSentAt
        ? "Dernière relance"
        : "Relancer la signature";
    const needsAdvancePaymentReminder = rental.advancePaymentAmountCentsNeeded > 0
        && (rental.amountAlreadyPaid ?? 0) < rental.advancePaymentAmountCentsNeeded
        && !rental.finalAdvancePaymentReminderSentAt;
    const advancePaymentReminderSent = rental.advancePaymentAmountCentsNeeded > 0
        && (rental.amountAlreadyPaid ?? 0) < rental.advancePaymentAmountCentsNeeded
        && rental.advancePaymentReminderSentAt;
    const finalAdvancePaymentReminderSent = rental.advancePaymentAmountCentsNeeded > 0
        && (rental.amountAlreadyPaid ?? 0) < rental.advancePaymentAmountCentsNeeded
        && rental.finalAdvancePaymentReminderSentAt;
    const nextAdvancePaymentReminderIsFinal = advancePaymentReminderSent && !finalAdvancePaymentReminderSent;
    // Les deux relances sont restées sans effet : le loueur peut clôturer la location et prévenir le locataire.
    const canCloseUnpaidAdvanceRental = advancePaymentReminderSent && finalAdvancePaymentReminderSent
        && status !== "Done" && status !== "Cancelled";
    const advancePaymentReminderLabel = nextAdvancePaymentReminderIsFinal
        ? "Dernière relance"
        : "Relancer l'acompte";
    const advancePaymentDeposited = rental.advancePaymentAmountCentsNeeded <= 0
        || (rental.amountAlreadyPaid ?? 0) >= rental.advancePaymentAmountCentsNeeded;
    const bankTransferInstruction = rental.advancePaymentBankTransferInstruction || rental.AdvancePaymentBankTransferInstruction;
    const bankTransferInstructionRequired = bankTransferInstruction?.isRequired ?? bankTransferInstruction?.IsRequired;
    const bankTransferInstructionReference = bankTransferInstruction?.transferReference ?? bankTransferInstruction?.TransferReference;
    const bankTransferInstructionAccountDetails = bankTransferInstruction?.bankAccountDetails ?? bankTransferInstruction?.BankAccountDetails;
    const showAdvancePaymentBankTransferInstruction = bankTransferInstructionRequired;
    const hasStripeDeposit = rental.depositType === "CB";
    const hasBankTransferDeposit = rental.depositType === "BankTransfer";
    const depositBankTransferInstruction = rental.depositBankTransferInstruction || rental.DepositBankTransferInstruction;
    const depositBankTransferReference = depositBankTransferInstruction?.transferReference ?? depositBankTransferInstruction?.TransferReference;
    const depositRefundBankAccountOwner = rental.depositRefundBankAccountOwner || rental.DepositRefundBankAccountOwner;
    const depositRefundIban = rental.depositRefundIban || rental.DepositRefundIban;
    const depositRefundBic = rental.depositRefundBic || rental.DepositRefundBic;
    const stripeDepositStatusLabel = status === "Done"
        ? "Libérée"
        : status === "Cancelled"
            ? "Annulée"
            : rental.depositDone
                ? "Déposée"
                : "À déposer";
    const normalizeSourceName = (value) => String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    const getRentalSourceIcon = (sourceName, servicePicture) => {
        const normalizedSourceName = normalizeSourceName(sourceName);
        if (normalizedSourceName.includes("bricolib")) {
            return { label: "Bricolib", icon: "pi pi-wrench", logoSrc: servicePicture, variant: "bricolib" };
        }
        if (normalizedSourceName.includes("kiwiiz")) {
            return { label: "Kiwiiz", icon: "pi pi-key", logoSrc: servicePicture, variant: "kiwiiz" };
        }
        if (normalizedSourceName.includes("allo")) {
            return { label: "AlloVoisins", icon: "pi pi-users", logoSrc: servicePicture, variant: "allovoisins" };
        }
        if (normalizedSourceName.includes("poppins")) {
            return { label: "Poppins", icon: "pi pi-box", logoSrc: servicePicture, variant: "poppins" };
        }
        if (normalizedSourceName.includes("omniloc")) {
            return { label: "Omniloc", icon: "pi pi-building", logoSrc: servicePicture, variant: "omniloc" };
        }
        if (normalizedSourceName.includes("jelouetout") || normalizedSourceName.includes("je loue tout")) {
            return { label: "JeLoueTout", icon: "pi pi-shopping-bag", logoSrc: servicePicture, variant: "jelouetout" };
        }
        if (normalizedSourceName.includes("yacalouer")) {
            return { label: "Yacalouer", icon: "pi pi-calendar", logoSrc: servicePicture, variant: "yacalouer" };
        }
        return { label: sourceName || "Lokapp", icon: "pi pi-home", logoSrc: servicePicture || "/logo192.png", variant: "lokapp" };
    };
    const serviceBase64Picture = rental.serviceBase64Picture || rental.ServiceBase64Picture;
    const rentalSourceIcon = getRentalSourceIcon(rental.serviceName, serviceBase64Picture);
    const canManuallyValidateAdvancePayment = needsSignNowSignature && !advancePaymentDeposited && nextstep === "ValidateSignatureNeeded";
    const displayStep = nextstep === "ValidateSignatureNeeded" && !advancePaymentDeposited
        ? null
        : nextstep;
    const formatAmount = (amountCents) => `${((amountCents ?? 0) / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}€`;
    // Caution déjà reçue quand on supprime ou annule la location : l'empreinte CB est libérée par l'API, le reste est à rendre à la main.
    const getDepositRefundNote = () => {
        if (!rental.deposit) {
            return null;
        }
        const amount = formatAmount(rental.deposit);
        if (hasStripeDeposit && rental.depositDone) {
            return { automatic: true, text: `La caution de ${amount} déposée par carte sera libérée et le locataire recevra le mail « Caution libérée ».` };
        }
        if (hasStripeDeposit && !IsNullOrEmpty(rental.permanentLinkDeposit) && nextsteps.includes("ReleaseDepositNeeded") && !nextsteps.includes("CBDepositNeeded")) {
            return { automatic: false, text: `La caution de ${amount} a été déposée via votre lien de paiement : pensez à la libérer dans Stripe.` };
        }
        if (hasBankTransferDeposit && rental.depositDone) {
            return { automatic: false, text: `La caution de ${amount} reçue par virement est à rembourser au locataire.` };
        }
        if (nextsteps.includes("ReleaseDepositCashNeeded") && !nextsteps.includes("CashDepositNeeded") && !nextsteps.includes("CheckDepositNeeded")) {
            return { automatic: false, text: `La caution de ${amount} (${rental.depositType === "Check" ? "chèque" : "espèces"}) est à rendre au locataire.` };
        }
        return null;
    };
    const depositRefundNote = getDepositRefundNote();
    const paymentFeeComparisons = (rental.paymentFeeConfigurations ?? [])
        .filter((configuration) => configuration?.name?.trim())
        .map((configuration) => {
            const percentage = Number(configuration.percentage ?? 0);
            const fixedFeeCents = Number(configuration.fixedFeeCents ?? 0);
            const feesCents = Math.round((rental.remainingToBePaidCents * percentage) / 100) + fixedFeeCents;
            return {
                ...configuration,
                feesCents,
                netCents: rental.remainingToBePaidCents - feesCents
            };
        })
        .sort((first, second) => first.feesCents - second.feesCents);
    const bestPaymentFeeComparison = rental.remainingToBePaidCents > 0 ? paymentFeeComparisons[0] : null;
    const statusLabels = {
        New: "À préparer",
        Confirmed: "Confirmée",
        InProgress: "En cours",
        Done: "Terminée",
        Cancelled: "Annulée"
    };
    const statusValue = String(status || "");
    const statusClass = `rental-detail-status rental-detail-status--${statusValue.toLowerCase()}`;
    const nextStepLabel = displayStep ? `${checklistLabels[nextstep][0]}${(nextstep === "NeedPayment") ? " de " + formatAmount(rental.remainingToBePaidCents) : ""}${(nextstep === "CashDepositNeeded") ? " : " + formatAmount(rental.deposit) : ""}` : "";
    const rentalMaterials = (rental.materials && rental.materials.length > 0)
        ? rental.materials
        : [{
            publicId: rental.toolPublicId,
            name: rental.name,
            base64Picture: rental.base64Picture
        }];
    // Une ligne par unité louée : 30 chaises = 30 fois le même matériel, affiché une fois avec sa quantité.
    const materialGroups = rentalMaterials.reduce((groups, material) => {
        const key = material.publicId || material.name;
        const group = groups.find(g => g.key === key);
        if (group) group.count += 1;
        else groups.push({ key, material, count: 1 });
        return groups;
    }, []);
    const formatStripeDate = (value) => value ? new Date(value).toLocaleString("fr-FR") : "—";
    const formatStripeAmount = (amount, currency = "eur") => {
        if (amount === null || amount === undefined) return "—";
        return `${formatAmount(amount)} ${String(currency || "").toUpperCase()}`.trim();
    };
    const stripePaymentIntent = stripeDepositLogs?.paymentIntent;
    const stripeCharge = stripeDepositLogs?.charge;
    const stripeEvents = Array.isArray(stripeDepositLogs?.events) ? stripeDepositLogs.events : [];
    return (
        <div>
            <Toast ref={toast}></Toast>

            <Dialog
                header="Récupérer la caution"
                visible={visible}
                modal
                className="rental-form-dialog rental-detail-dialog"
                style={{ width: '30rem', maxWidth: '95vw' }}
                onHide={() => { if (!visible) return; setVisible(false); }}
                footer={
                    <div className="rental-form-dialog-footer">
                        <Button label="Annuler" onClick={() => setVisible(false)} text severity="secondary" />
                        <Button label="Récupérer" icon="pi pi-check" loading={isCapturingDeposit} disabled={!captureTotalCents} onClick={captureDeposit} />
                    </div>
                }
            >
                <div className="rental-form-dialog-body">
                    <p className="rental-form-dialog-intro">Listez les frais récupérés sur la caution. Le total sera encaissé.</p>
                    {captureFees.map((fee, index) => (
                        <div key={index} className="rental-capture-fee-row">
                            <InputText className="rental-capture-fee-description" value={fee.description} onChange={(event) => updateCaptureFee(index, 'description', event.target.value)} placeholder="Libellé du frais" />
                            <InputText className="rental-capture-fee-amount" value={fee.amount} keyfilter="money" onChange={(event) => updateCaptureFee(index, 'amount', event.target.value)} placeholder="Montant" />
                            <span className="rental-capture-fee-currency">€</span>
                            {captureFees.length > 1 && <Button icon="pi pi-trash" text severity="danger" aria-label="Supprimer ce frais" onClick={() => setCaptureFees(fees => fees.filter((_, feeIndex) => feeIndex !== index))} />}
                        </div>
                    ))}
                    <Button label="Ajouter un frais" icon="pi pi-plus" text onClick={() => setCaptureFees(fees => [...fees, { description: '', amount: '' }])} />
                    <p style={{ marginTop: '1rem', fontWeight: 600 }}>Total récupéré : {formatAmount(captureTotalCents)}</p>
                </div>
            </Dialog>
            <Dialog
                header="Frais de paiement"
                visible={paymentfeesvisible}
                modal
                className="rental-form-dialog rental-detail-dialog"
                style={{ width: '30rem', maxWidth: '95vw' }}
                onHide={() => { if (!paymentfeesvisible) return; setPaymentfeesvisible(false); }}
                footer={
                    <div className="rental-form-dialog-footer">
                        <Button label="Annuler" onClick={() => setPaymentfeesvisible(false)} text severity="secondary" />
                        <Button label="Valider" icon="pi pi-check" onClick={authorizeStripePayment} />
                    </div>
                }
            >
                <div className="rental-form-dialog-body">
                    <p className="rental-form-dialog-intro">Renseignez les frais appliqués à ce paiement.</p>
                    <span className="p-float-label">
                        <InputText keyfilter="money" id="paymentFeesAmount" />
                        <label htmlFor="paymentFeesAmount">Frais</label>
                    </span>
                </div>
            </Dialog>
            <Dialog
                header="Logs Stripe de la caution"
                visible={stripeDepositLogsVisible}
                modal
                baseZIndex={1700}
                className="rental-form-dialog rental-detail-dialog rental-stripe-logs-dialog"
                style={{ width: '46rem', maxWidth: '96vw' }}
                onHide={() => { if (!stripeDepositLogsVisible) return; setStripeDepositLogsVisible(false); }}
                footer={
                    <div className="rental-form-dialog-footer">
                        <Button label="Recharger" icon="pi pi-refresh" onClick={loadStripeDepositLogsAction} loading={isStripeDepositLogsLoading} text severity="secondary" />
                        <Button label="Fermer" icon="pi pi-times" onClick={() => setStripeDepositLogsVisible(false)} text severity="secondary" />
                    </div>
                }
            >
                <div className="rental-form-dialog-body rental-stripe-logs">
                    {isStripeDepositLogsLoading && !stripeDepositLogs ? (
                        <p className="rental-form-dialog-intro">Récupération des informations directement depuis Stripe...</p>
                    ) : stripeDepositLogs?.status === "NotCreated" ? (
                        <p className="rental-form-dialog-intro">{stripeDepositLogs.message}</p>
                    ) : stripePaymentIntent ? (
                        <>
                            <div className="rental-stripe-summary">
                                <div>
                                    <span>PaymentIntent</span>
                                    <b>{stripePaymentIntent.id}</b>
                                </div>
                                <div>
                                    <span>Statut Stripe</span>
                                    <b>{stripePaymentIntent.status || "—"}</b>
                                </div>
                                <div>
                                    <span>Montant autorisé</span>
                                    <b>{formatStripeAmount(stripePaymentIntent.amount, stripePaymentIntent.currency)}</b>
                                </div>
                                <div>
                                    <span>Capturable</span>
                                    <b>{formatStripeAmount(stripePaymentIntent.amountCapturable, stripePaymentIntent.currency)}</b>
                                </div>
                                <div>
                                    <span>Créé chez Stripe</span>
                                    <b>{formatStripeDate(stripePaymentIntent.created)}</b>
                                </div>
                                <div>
                                    <span>Statut Lokapp</span>
                                    <b>{stripeDepositLogs.localDepositStatus || "—"}</b>
                                </div>
                            </div>

                            {stripeDepositLogs.lastPaymentError && (
                                <div className="rental-stripe-error">
                                    <b>Dernière erreur Stripe</b>
                                    <span>{stripeDepositLogs.lastPaymentError.message || "Erreur Stripe sans message."}</span>
                                    <small>
                                        {[stripeDepositLogs.lastPaymentError.type, stripeDepositLogs.lastPaymentError.code, stripeDepositLogs.lastPaymentError.declineCode].filter(Boolean).join(" · ")}
                                    </small>
                                </div>
                            )}

                            {stripeCharge && (
                                <div className="rental-stripe-card">
                                    <div>
                                        <span>Charge</span>
                                        <b>{stripeCharge.id}</b>
                                    </div>
                                    <div>
                                        <span>Résultat</span>
                                        <b>{stripeCharge.status || "—"}</b>
                                        {stripeCharge.failureMessage && <small>{stripeCharge.failureMessage}</small>}
                                    </div>
                                    <div>
                                        <span>Carte</span>
                                        <b>
                                            {stripeCharge.paymentMethod?.card?.brand || stripeCharge.paymentMethod?.type || "—"}
                                            {stripeCharge.paymentMethod?.card?.last4 ? ` · **** ${stripeCharge.paymentMethod.card.last4}` : ""}
                                        </b>
                                        <small>
                                            {[stripeCharge.paymentMethod?.card?.country, stripeCharge.paymentMethod?.card?.funding, stripeCharge.paymentMethod?.card?.threeDSecureResult ? `3DS ${stripeCharge.paymentMethod.card.threeDSecureResult}` : null].filter(Boolean).join(" · ")}
                                        </small>
                                    </div>
                                    {stripeCharge.outcome && (
                                        <div>
                                            <span>Analyse Stripe</span>
                                            <b>{stripeCharge.outcome.sellerMessage || stripeCharge.outcome.type || "—"}</b>
                                            <small>{[stripeCharge.outcome.riskLevel, stripeCharge.outcome.reason].filter(Boolean).join(" · ")}</small>
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="rental-stripe-events">
                                <div className="rental-stripe-events-header">
                                    <b>Événements Stripe</b>
                                    <span>{stripeEvents.length} événement{stripeEvents.length > 1 ? "s" : ""}</span>
                                </div>
                                {stripeEvents.length === 0 ? (
                                    <p>Aucun événement Stripe récent lié à cette caution n'a été retourné.</p>
                                ) : stripeEvents.map((event) => (
                                    <div className="rental-stripe-event" key={event.id}>
                                        <i className="pi pi-circle-fill" aria-hidden="true"></i>
                                        <div>
                                            <b>{event.type}</b>
                                            <span>{formatStripeDate(event.created)}</span>
                                            {event.message && <small>{event.message}</small>}
                                            <small>{[event.id, event.objectId, event.requestId ? `request ${event.requestId}` : null].filter(Boolean).join(" · ")}</small>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <small className="rental-stripe-retention-note">{stripeDepositLogs.retentionNote}</small>
                        </>
                    ) : (
                        <p className="rental-form-dialog-intro">Aucune donnée Stripe disponible pour cette caution.</p>
                    )}
                </div>
            </Dialog>
            <div id="thumbnail" className={`rental-detail-modern${hasRentalSidePanel ? "" : " rental-detail-modern--full"}`}>
                <div className="middlePublicRentalHeader">
                    <div className="rental-detail-heading">
                        <div className={"rental-detail-material-gallery rental-detail-material-gallery--" + Math.min(materialGroups.length, 4)}>
                            {materialGroups.slice(0, 4).map(({ key, material, count }, index) => (
                                <a
                                    className="rental-detail-material-thumb"
                                    href={`/monoutil/${material.publicId}`}
                                    key={key || index}
                                    title={count > 1 ? `${material.name} (${count})` : material.name}
                                >
                                    <img className="rentalPicture" alt={material.name || rental.name} src={material.base64Picture || rental.base64Picture || null} />
                                    {count > 1 && (
                                        <span className="rental-detail-material-count" aria-label={`${count} unités`}>×{count}</span>
                                    )}
                                </a>
                            ))}
                            {materialGroups.length > 4 && (
                                <span className="rental-detail-material-more">+{materialGroups.length - 4}</span>
                            )}
                        </div>
                        <div className="rental-detail-heading-main">
                            <div className="rental-detail-modern-status">
                                <span className={statusClass}>{statusLabels[status] || status}</span>
                                <span
                                    className={`rental-source-inline rental-source-inline--${rentalSourceIcon.variant}`}
                                    title={rentalSourceIcon.label}
                                    aria-label={`Source : ${rentalSourceIcon.label}`}
                                >
                                    {rentalSourceIcon.logoSrc && (
                                        <img
                                            src={rentalSourceIcon.logoSrc}
                                            alt=""
                                            aria-hidden="true"
                                            onError={(event) => {
                                                event.currentTarget.hidden = true;
                                                const fallbackIcon = event.currentTarget.nextElementSibling;
                                                if (fallbackIcon) {
                                                    fallbackIcon.hidden = false;
                                                }
                                            }}
                                        />
                                    )}
                                    <i className={rentalSourceIcon.icon} aria-hidden="true" hidden={Boolean(rentalSourceIcon.logoSrc)}></i>
                                </span>
                            </div>
                            <h1 className="h1RentalTitle"><a href={toolLink}  >{rental.name}</a>
                                <div className="actionsRentalTitle">
                                <span className="action">
                                    <ConfirmPopup />
                                    <Form className="actionForm" action="modifier">
                                        <Button icon="pi pi-pencil" size="small" type="submit" severity="secondary" data-cy="updateBtn" ></Button>
                                    </Form>
                                </span>
                                    <span className="action">
                                    {(status === "Cancelled") ? (<></>)
                                        : (
                                            <Button onClick={deleteLocation} icon="pi pi-trash" label="" size="small" className="p-button-danger" data-cy="deleteRental"></Button>
                                        )}

                                    </span >

                                </div>
                            </h1>
                        </div>
                    </div>

                    <RentalDeliveryVehicleNotice rentalPublicId={rental.rentalPublicId} refreshKey={status} />
                    <div id="thumbnail-form" className="rental-detail-meta">
                        <div className="rental-detail-meta-item">
                            <span>Client</span>
                            <b><a href={clientLink}>{rental.clientFirstname} {rental.clientLastname}</a></b>
                        </div>
                        <div className="rental-detail-meta-item">
                            <span>Téléphone</span>
                            <b>{rental.clientPhone}</b>
                        </div>
                        <div className="rental-detail-period">
                            <span>Période</span>
                            <div className="rental-detail-period-range">
                                <b>
                                    <small>Début</small>
                                    <strong>
                                        <Moment locale="fr" calendar={calendarStrings}>
                                            {new Date(rental.startDate)}
                                        </Moment>
                                    </strong>
                                </b>
                                <b>
                                    <small>Fin</small>
                                    <strong>
                                        <Moment locale="fr" calendar={calendarStrings}>
                                            {new Date(rental.endDate)}
                                        </Moment>
                                    </strong>
                                </b>
                            </div>
                        </div>
                        {rental.depositReminderSentAt && (
                            <div className="rental-detail-meta-item">
                                <span>Relance caution CB</span>
                                <b>
                                    Envoyée&nbsp;
                                    <Moment locale="fr" calendar={calendarStrings}>
                                        {new Date(rental.depositReminderSentAt)}
                                    </Moment>
                                </b>
                            </div>
                        )}
                        {Array.isArray(rental.rentalContacts) && rental.rentalContacts.map((contact, index) => (
                            <div className="rental-detail-meta-item rental-detail-meta-item--contact" key={`${contact.name}-${index}`}>
                                <span>{contact.role ? `Contact · ${contact.role}` : 'Contact additionnel'}</span>
                                <b>{contact.name}</b>
                                {(contact.phone || contact.email) && (
                                    <small>{[contact.phone, contact.email].filter(Boolean).join(' · ')}</small>
                                )}
                            </div>
                        ))}
                        {rental.comment && (
                            <b className="rental-detail-meta-note">
                                {rental.comment}
                            </b>
                        )}
                    </div>
                    <div className={`rental-detail-financial-row${hasStripeDeposit ? "" : " rental-detail-financial-row--single"}`}>
                        <div className="editremainingAmount rental-detail-payment-summary">
                            {(rental.amountAlreadyPaid > 0) ? (
                                <span><small>Déjà versé</small><b>{formatAmount(rental.amountAlreadyPaid)}</b></span>

                            ) : (
                                <span><small>Acompte</small><b>Aucun acompte déposé</b></span>
                            )}
                            <span><small>Reste dû</small><b>{formatAmount(rental.remainingToBePaidCents)}</b></span>
                            {bestPaymentFeeComparison && (
                                <div className="rental-payment-fee-comparison">
                                    <div className="rental-payment-fee-comparison__recommendation">
                                        <i className="pi pi-chart-line" aria-hidden="true"></i>
                                        <span>
                                            <small>Encaissement le plus avantageux</small>
                                            <b>{bestPaymentFeeComparison.name} · frais estimés {formatAmount(bestPaymentFeeComparison.feesCents)}</b>
                                        </span>
                                    </div>
                                    <details>
                                        <summary>Voir le calcul des {paymentFeeComparisons.length} service{paymentFeeComparisons.length > 1 ? "s" : ""}</summary>
                                        <div className="rental-payment-fee-comparison__details">
                                            {paymentFeeComparisons.map((comparison) => (
                                                <div key={comparison.name}>
                                                    <b>{comparison.name}</b>
                                                    <span>{comparison.percentage}% + {formatAmount(comparison.fixedFeeCents)} = {formatAmount(comparison.feesCents)} de frais</span>
                                                    <small>Vous conservez {formatAmount(comparison.netCents)}</small>
                                                </div>
                                            ))}
                                        </div>
                                    </details>
                                </div>
                            )}
                            {showAdvancePaymentBankTransferInstruction && (
                                <div className="rental-payment-fee-comparison rental-payment-fee-comparison--bank-transfer">
                                    <div className="rental-payment-fee-comparison__recommendation">
                                        <i className="pi pi-send" aria-hidden="true"></i>
                                        <span>
                                            <small>Acompte par virement instantané</small>
                                            <b>Acompte à recevoir hors plateforme : {formatAmount(rental.advancePaymentAmountCentsNeeded)}</b>
                                            <small>Motif du virement : {bankTransferInstructionReference}</small>
                                            {bankTransferInstructionAccountDetails && (
                                                <small>{bankTransferInstructionAccountDetails.split('\n').map((line) => <React.Fragment key={line}>{line}<br /></React.Fragment>)}</small>
                                            )}
                                        </span>
                                    </div>
                                </div>
                            )}
                            {needsAdvancePaymentReminder && (
                                <Button
                                    className="rental-detail-payment-reminder"
                                    icon="pi pi-envelope"
                                    label={advancePaymentReminderLabel}
                                    loading={isAdvancePaymentReminderLoading}
                                    disabled={isAdvancePaymentReminderLoading}
                                    onClick={sendAdvancePaymentReminderAction}
                                    rounded
                                    text
                                    severity="secondary"
                                />
                            )}
                            {canCloseUnpaidAdvanceRental && (
                                <Button
                                    className="rental-detail-payment-reminder"
                                    icon="pi pi-ban"
                                    label="Clôturer la location"
                                    onClick={openUnpaidAdvanceClosure}
                                    rounded
                                    text
                                    severity="danger"
                                />
                            )}
                            {advancePaymentReminderSent && (
                                <small className="rental-detail-payment-note">
                                    Première relance envoyée&nbsp;
                                    <Moment locale="fr" calendar={calendarStrings}>
                                        {new Date(rental.advancePaymentReminderSentAt)}
                                    </Moment>
                                </small>
                            )}
                            {finalAdvancePaymentReminderSent && (
                                <small className="rental-detail-payment-note">
                                    Dernière relance envoyée&nbsp;
                                    <Moment locale="fr" calendar={calendarStrings}>
                                        {new Date(rental.finalAdvancePaymentReminderSentAt)}
                                    </Moment>
                                </small>
                            )}
                            <Button className="rental-detail-payment-edit" icon="pi pi-pencil" onClick={() => setRemainingToBePaidCentsVisible(true)} rounded text severity="secondary" aria-label="Edit" />
                        </div>

                        {hasStripeDeposit && (
                            <div className="editremainingAmount rental-detail-stripe-deposit-summary">
                                <span>
                                    <small>Caution Stripe</small>
                                    <b>{stripeDepositStatusLabel}</b>
                                </span>
                                <span>
                                    <small>Montant</small>
                                    <b>{formatAmount(rental.deposit)}</b>
                                </span>
                                <Button
                                    className="rental-detail-stripe-deposit-action"
                                    icon="pi pi-list"
                                    onClick={loadStripeDepositLogsAction}
                                    loading={isStripeDepositLogsLoading}
                                    rounded
                                    text
                                    severity="secondary"
                                    aria-label="Logs Stripe de la caution"
                                    title="Logs Stripe de la caution"
                                />
                            </div>
                        )}
                        {hasBankTransferDeposit && (
                            <div className="editremainingAmount rental-detail-stripe-deposit-summary">
                                <span>
                                    <small>Caution par virement</small>
                                    <b>{rental.depositDone ? "Reçue" : "À recevoir"}</b>
                                </span>
                                <span>
                                    <small>Montant</small>
                                    <b>{formatAmount(rental.deposit)}</b>
                                </span>
                                {depositBankTransferReference && (
                                    <span>
                                        <small>Motif</small>
                                        <b>{depositBankTransferReference}</b>
                                    </span>
                                )}
                                <span>
                                    <small>RIB locataire</small>
                                    <b>{depositRefundIban ? `${depositRefundBankAccountOwner || "Titulaire non renseigné"} - ${depositRefundIban}${depositRefundBic ? ` - ${depositRefundBic}` : ""}` : "En attente"}</b>
                                </span>
                            </div>
                        )}
                    </div>

                    {needsSignNowSignature && (
                        <div className="editremainingAmount">
                            <span>Signature électronique : <b>{getSignNowStatusLabel()}</b></span>
                            {rental.signNowSignedAt && (
                                <span>
                                    &nbsp;(&nbsp;
                                    <Moment locale="fr" calendar={calendarStrings}>
                                        {new Date(rental.signNowSignedAt)}
                                    </Moment>
                                    &nbsp;)
                                </span>
                            )}
                            {displayStep === "ValidateSignatureNeeded" && (
                                <span className="ml-2">
                                    <i>À valider dans le flow ci-dessous.</i>
                                </span>
                            )}
                            {rental.electronicSignatureReminderSentAt && (
                                <small className="rental-detail-payment-note ml-2">
                                    {rental.finalElectronicSignatureReminderSentAt ? "Première relance envoyée" : "Relance envoyée"}&nbsp;
                                    <Moment locale="fr" calendar={calendarStrings}>
                                        {new Date(rental.electronicSignatureReminderSentAt)}
                                    </Moment>
                                </small>
                            )}
                            {rental.finalElectronicSignatureReminderSentAt && (
                                <small className="rental-detail-payment-note ml-2">
                                    Dernière relance envoyée&nbsp;
                                    <Moment locale="fr" calendar={calendarStrings}>
                                        {new Date(rental.finalElectronicSignatureReminderSentAt)}
                                    </Moment>
                                </small>
                            )}
                            <Button
                                className="ml-2"
                                size="small"
                                text
                                label="Renvoyer le contrat dans SignNow"
                                icon="pi pi-send"
                                loading={signNowUpdating}
                                onClick={resendSignNowSignatureAction}
                            />
                            {needsElectronicSignatureReminder && (
                                <Button
                                    className="ml-2"
                                    size="small"
                                    text
                                    label={electronicSignatureReminderLabel}
                                    icon="pi pi-envelope"
                                    loading={isElectronicSignatureReminderLoading}
                                    disabled={isElectronicSignatureReminderLoading}
                                    onClick={sendElectronicSignatureReminderAction}
                                />
                            )}
                        </div>
                    )}
                    {canManuallyValidateAdvancePayment && (
                        <div className="editremainingAmount">
                            <span>En cas de paiement hors plateforme (virement, espèces, etc.), validez l&apos;acompte manuellement pour lancer la signature électronique.</span>
                            <Button
                                label="Valider l'acompte manuellement"
                                icon="pi pi-check-circle"
                                onClick={() => setRemainingToBePaidCentsVisible(true)}
                                text
                            />
                        </div>
                    )}

                    <Dialog
                        header="Modifier le paiement"
                        visible={remainingToBePaidCentsVisible}
                        modal
                        className="rental-form-dialog rental-detail-dialog"
                        style={{ width: '34rem', maxWidth: '95vw' }}
                        onHide={() => { if (!remainingToBePaidCentsVisible) return; setRemainingToBePaidCentsVisible(false); }}
                        footer={
                            <div className="rental-form-dialog-footer">
                                <Button label="Fermer" icon="pi pi-times" onClick={() => setRemainingToBePaidCentsVisible(false)} text severity="secondary" />
                            </div>
                        }
                    >
                        <div className="rental-form-dialog-body">
                            <p className="rental-form-dialog-intro">
                                Ajustez le reste dû ou ajoutez un acompte reçu hors plateforme.
                            </p>
                            <div className="rental-detail-dialog-action">
                                <span className="p-float-label">
                                    <InputText keyfilter="money" id="remainingToBePaid" />
                                    <label htmlFor="remainingToBePaid">Reste à payer ({rental.remainingToBePaidCents / 100}€)</label>
                                </span>
                                <Button label="Modifier" icon="pi pi-pencil" onClick={remainingToBePaidAction} />
                            </div>
                            <div className="rental-detail-dialog-action">
                                <span className="p-float-label">
                                    <InputText keyfilter="money" id="advancedPayment" />
                                    <label htmlFor="advancedPayment">Ajouter un acompte</label>
                                </span>
                                <Button label="Ajouter" icon="pi pi-plus" loading={isManualAdvanceLoading} disabled={isManualAdvanceLoading} onClick={addAdvancedPaymentAction} />
                            </div>
                            <label className="settings-toggle-field">
                                <Checkbox
                                    inputId="sendManualAdvancePaymentEmail"
                                    checked={sendManualAdvancePaymentEmail}
                                    onChange={(event) => setSendManualAdvancePaymentEmail(event.checked)}
                                />
                                <span>
                                    <b>Envoyer un mail de confirmation au client</b>
                                    <small>Le client sera informé que l'acompte a bien été reçu.</small>
                                </span>
                            </label>
                        </div>
                    </Dialog>

                    <Dialog
                        header="Clôturer la location"
                        visible={unpaidAdvanceClosureVisible}
                        modal
                        className="rental-form-dialog rental-detail-dialog"
                        style={{ width: '36rem', maxWidth: '95vw' }}
                        onHide={() => { if (!unpaidAdvanceClosureVisible) return; setUnpaidAdvanceClosureVisible(false); }}
                        footer={
                            <div className="rental-form-dialog-footer">
                                <Button label="Annuler" onClick={() => setUnpaidAdvanceClosureVisible(false)} text severity="secondary" disabled={isUnpaidAdvanceClosureLoading} />
                                <Button
                                    label={sendUnpaidAdvanceClosureEmail ? "Clôturer et prévenir" : "Clôturer"}
                                    icon="pi pi-ban"
                                    severity="danger"
                                    loading={isUnpaidAdvanceClosureLoading}
                                    disabled={isUnpaidAdvanceClosureLoading}
                                    onClick={closeUnpaidAdvanceRentalAction}
                                />
                            </div>
                        }
                    >
                        <div className="rental-form-dialog-body">
                            <p className="rental-form-dialog-intro">
                                L'acompte de {formatAmount(rental.advancePaymentAmountCentsNeeded)} n'a pas été réglé malgré les deux relances.
                                La location sera annulée : les étapes à venir sont supprimées et le matériel est remis à disposition.
                                Vous pourrez la réouvrir si besoin.
                            </p>
                            {(rental.amountAlreadyPaid ?? 0) > 0 && (
                                <p className="rental-closure-warning">
                                    <i className="pi pi-exclamation-triangle" aria-hidden="true"></i>
                                    <span>{formatAmount(rental.amountAlreadyPaid)} ont déjà été versés : pensez à les rembourser au locataire.</span>
                                </p>
                            )}
                            <label className="settings-toggle-field">
                                <Checkbox
                                    inputId="sendUnpaidAdvanceClosureEmail"
                                    checked={sendUnpaidAdvanceClosureEmail}
                                    onChange={(event) => setSendUnpaidAdvanceClosureEmail(event.checked)}
                                />
                                <span>
                                    <b>Prévenir le locataire par mail</b>
                                    <small>
                                        Envoyé à {rental.clientEmail}. Le mail indique que la réservation est annulée faute d'acompte
                                        et l'invite à refaire une demande s'il a toujours besoin du matériel.
                                    </small>
                                </span>
                            </label>
                            {sendUnpaidAdvanceClosureEmail && (
                                <div className="rental-closure-email-preview">
                                    {isUnpaidAdvanceClosureEmailLoading ? (
                                        <small>Préparation de l'aperçu du mail...</small>
                                    ) : unpaidAdvanceClosureEmail ? (
                                        <>
                                            <b>{unpaidAdvanceClosureEmail.subject}</b>
                                            <p>{unpaidAdvanceClosureEmail.body}</p>
                                            <small>Texte modifiable dans Paramètres › Emails, modèle « Location clôturée faute d'acompte ».</small>
                                        </>
                                    ) : (
                                        <small>L'aperçu du mail n'est pas disponible.</small>
                                    )}
                                </div>
                            )}
                        </div>
                    </Dialog>

                    <Dialog
                        header="Supprimer la location"
                        visible={cancelRentalVisible}
                        modal
                        className="rental-form-dialog rental-detail-dialog"
                        style={{ width: '36rem', maxWidth: '95vw' }}
                        onHide={() => { if (!cancelRentalVisible) return; setCancelRentalVisible(false); }}
                        footer={
                            <div className="rental-form-dialog-footer">
                                <Button label="Annuler" onClick={() => setCancelRentalVisible(false)} text severity="secondary" disabled={isCancelRentalLoading} />
                                <Button
                                    label={sendCancellationEmail ? "Supprimer et prévenir" : "Supprimer"}
                                    icon="pi pi-trash"
                                    severity="danger"
                                    loading={isCancelRentalLoading}
                                    disabled={isCancelRentalLoading || (sendCancellationEmail && !cancellationReason.trim())}
                                    onClick={cancelRentalAction}
                                    data-cy="confirmDeleteRental"
                                />
                            </div>
                        }
                    >
                        <div className="rental-form-dialog-body">
                            <p className="rental-form-dialog-intro">
                                La location sera annulée : les étapes à venir sont supprimées et le matériel est remis à disposition.
                                Vous pourrez la réouvrir si besoin.
                            </p>
                            {(rental.amountAlreadyPaid ?? 0) > 0 && (
                                <p className="rental-closure-warning">
                                    <i className="pi pi-exclamation-triangle" aria-hidden="true"></i>
                                    <span>{formatAmount(rental.amountAlreadyPaid)} ont déjà été versés : pensez à les rembourser au locataire.</span>
                                </p>
                            )}
                            {depositRefundNote && (
                                <p className={depositRefundNote.automatic ? "rental-closure-info" : "rental-closure-warning"} data-cy="cancelRentalDepositNote">
                                    <i className={depositRefundNote.automatic ? "pi pi-lock-open" : "pi pi-exclamation-triangle"} aria-hidden="true"></i>
                                    <span>{depositRefundNote.text}</span>
                                </p>
                            )}
                            <label className="settings-toggle-field">
                                <Checkbox
                                    inputId="sendCancellationEmail"
                                    checked={sendCancellationEmail}
                                    disabled={!rental.clientEmail}
                                    onChange={(event) => toggleCancellationEmail(event.checked)}
                                />
                                <span>
                                    <b>Prévenir le locataire par mail</b>
                                    <small>
                                        {rental.clientEmail
                                            ? <>Envoyé à {rental.clientEmail}, avec la raison de l'annulation.</>
                                            : <>Aucune adresse mail n'est renseignée pour ce locataire.</>}
                                    </small>
                                </span>
                            </label>
                            {sendCancellationEmail && (
                                <>
                                    <label className="rental-cancellation-reason" htmlFor="cancellationReason">
                                        <b>Raison de l'annulation</b>
                                        <InputTextarea
                                            id="cancellationReason"
                                            value={cancellationReason}
                                            onChange={(event) => setCancellationReason(event.target.value)}
                                            rows={3}
                                            maxLength={1000}
                                            placeholder="Ex. : le matériel est tombé en panne et ne pourra pas être réparé à temps."
                                            autoFocus
                                        />
                                    </label>
                                    <div className="rental-closure-email-preview">
                                        {isCancellationEmailLoading ? (
                                            <small>Préparation de l'aperçu du mail...</small>
                                        ) : cancellationEmail ? (
                                            <>
                                                <b>{cancellationEmail.subject}</b>
                                                <p>{cancellationEmail.body.split("{{cancellationReason}}").join(cancellationReason.trim() || "…")}</p>
                                                <small>Texte modifiable dans Paramètres › Emails, modèle « Location annulée par le loueur ».</small>
                                            </>
                                        ) : (
                                            <small>L'aperçu du mail n'est pas disponible.</small>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </Dialog>


                    <Dialog
                        header="Étapes à venir"
                        visible={stepsVisible}
                        modal
                        className="rental-form-dialog rental-detail-dialog"
                        style={{ width: 'min(36rem, 92vw)' }}
                        onHide={() => { if (!stepsVisible) return; setStepsVisible(false); }}
                    >
                        <div className="rental-form-dialog-body">
                            {nextsteps.length === 0 ? (
                                <span className="rental-form-dialog-intro">Aucune étape à venir.</span>
                            ) : nextsteps.map((step) => (
                                <div key={step} className="rental-detail-dialog-step">
                                    <span>{getStepLabel(step)}</span>
                                    <Button
                                        icon="pi pi-trash"
                                        rounded
                                        text
                                        severity="danger"
                                        size="small"
                                        aria-label={"Supprimer " + getStepLabel(step)}
                                        loading={deletingStep === step}
                                        disabled={deletingStep !== null}
                                        onClick={(event) => removeRentalStep(step, event)}
                                    />
                                </div>
                            ))}
                        </div>
                    </Dialog>

                   
                    {(displayStep) && (
                        <div className="nextStepContent rental-detail-workflow">
                            <div className="rental-detail-workflow-label">
                                <span>Prochaine action</span>
                            </div>
                            <div className="formCheckbox nextStep rental-detail-workflow-actions">
                               
                                <Button
                                    data-cy="nextStepBtn"
                                    disabled={isNextStepLoading || (nextstep === "DepositMailLinkNeeded" && !canSendDepositMail) || (rental.remainingToBePaidCents > 0 && (nextstep === "ReleaseDepositNeeded" || nextstep === "ReleaseDepositCashNeeded" || nextstep === "ReleaseDepositBankTransferNeeded"))}
                                    loading={isNextStepLoading}
                                    onClick={goToNextStep}
                                    size="large"
                                    className="iconSteps rental-detail-primary-step"
                                    icon={"pi " + checklistLabels[nextstep][1]}
                                    label={nextStepLabel}
                                />

                                {canManageSteps && (
                                    <Button
                                        icon="pi pi-list"
                                        label={`Étapes (${nextsteps.length})`}
                                        text
                                        severity="secondary"
                                        className="rental-detail-steps-button"
                                        onClick={() => setStepsVisible(true)}
                                    />
                                )}

                                {displayStep === "ReleaseDepositNeeded" && IsNullOrEmpty(rental.permanentLinkDeposit) ? (
                                    <Button data-cy="nextStepBtn" onClick={(e) => setVisible(true)} size="large" className="iconSteps p-button-danger" icon="pi pi-lock" label="Récupérer une partie" />
                                ) : ""}

                                {displayStep === "CBDepositNeeded" ? (
                                    <>
                                    <Menu model={option_deposit} popup ref={menuLeft} id="popup_menu_left" />
                                    <Button
                                        icon="pi pi-ellipsis-v"
                                        label="Options"
                                        className="rental-detail-deposit-options-button"
                                        onClick={(event) => menuLeft.current.toggle(event)}
                                        aria-controls="popup_menu_left"
                                        aria-haspopup
                                        text
                                        severity="secondary"
                                    />
                                    </>
                                ) : ""}

                                {displayStep === "NeedPayment" ? (
                                    <>
                                    <Menu model={option_payment} popup ref={menuLeft} id="popup_menu_left" />
                                    <Button
                                        icon="pi pi-ellipsis-v"
                                        label="Options"
                                        className="rental-detail-deposit-options-button"
                                        onClick={(event) => menuLeft.current.toggle(event)}
                                        aria-controls="popup_menu_left"
                                        aria-haspopup
                                        text
                                        severity="secondary"
                                    />
                                    </>
                                ) : ""}

                            
                            </div>

                        </div>
                    )}


                        {
                        status === "InProgress" && (!nextstep) &&
                            <div className="flex justify-center">
                                    <Form className="actionForm" method="post" action="done"
                                        onSubmit={(event) => {
                                            if (false) {
                                                event.preventDefault();
                                            }
                                        }} >
                                        <Button type="submit" >Terminer</Button>
                                    </Form>

                                </div>
                        }
                        {
                        status === "Cancelled" &&
                            <div className="flex justify-center">
                                <div className="flex flex-column align-items-center gap-2">
                                    <i>Location annulée</i>
                                    <Button severity="secondary" onClick={reopenLocation}>Réouvrir la location</Button>
                                </div>
                            </div>
                        }
                        {
                        status === "Done" &&
                            <>
                                <div className="flex justify-center">
                                    <i>Location terminée</i>
                                </div>
                                <RentalSatisfactionPanel rentalPublicId={rental.rentalPublicId} />
                            </>
                        }
                    

                </div>

                {hasRentalSidePanel && (
                    <>
                    <div className="push"></div>
                        <div className="contentRightPublicRentalHeader">
                            {rental.delivery !== "NoDelivery" && (
                                <div className="rightPublicRentalHeader">
                                    <h3>{hasDelivery ? "Livraison" : "Reprise"}</h3>

                                    <div className="rental-delivery-address-row">
                                        <span>{rental.deliveryAddress || rental.clientAddress}</span>
                                        <Button
                                            type="button"
                                            icon="pi pi-copy"
                                            text
                                            rounded
                                            severity="secondary"
                                            aria-label="Copier l'adresse"
                                            tooltip="Copier l'adresse"
                                            disabled={IsNullOrEmpty(rental.deliveryAddress || rental.clientAddress)}
                                            onClick={copyRentalAddress}
                                        />
                                    </div>

                                    <p>{rental.deliveryMemo}</p>
                                    {rental.deliveryDurationSeconds > 0 && (
                                        <p className="rental-delivery-trip">
                                            <i className="pi pi-car" aria-hidden="true"></i>
                                            <span>{formatTripDistance(rental.deliveryDistanceMeters)} · {formatTripDuration(rental.deliveryDurationSeconds)} de trajet simple</span>
                                        </p>
                                    )}
                                    {hasDelivery && (
                                        <Button
                                            icon="pi pi-print"
                                            label="Imprimer le bon de livraison"
                                            loading={isDeliveryReceiptPrinting}
                                            disabled={isDeliveryReceiptPrinting}
                                            onClick={printDeliveryReceiptAction}
                                            severity="secondary"
                                            size="small"
                                        />
                                    )}
                                </div>
                            )}

                            {hasMerchandiseItems && (
                                <div className="rightPublicRentalHeader rental-merchandise-panel">
                                    <h3>Marchandises à fournir</h3>
                                    <ul>
                                        {merchandiseItems.map(item => (
                                            <li key={item.id}>
                                                <span>{item.name}</span>
                                                <b>x{item.quantity}</b>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </>
                )}
     
              
            </div>
            {(rental.pdf) && (
            <div id="mainContent" className="rental-contract-panel">
                <div className="rental-contract-panel__header">
                    <h2>Contrat</h2>
                    <Button
                        icon="pi pi-download"
                        label="Télécharger le contrat complet"
                        loading={isFullContractDownloading}
                        disabled={isFullContractDownloading}
                        onClick={downloadFullContractAction}
                        severity="secondary"
                    />
                </div>
                {(needMessage) ? 
                    <div className="explain">Certains éléments qui vous concernent sont manquants dans le contrat. Vous pouvez les compléter directement sur votre compte et revenir sur cette page ! <a href="/moncompte" rel="noopener noreferrer" >
                        <i className="pi pi-user-edit" ></i> Accéder à mon compte
                    </a></div>
                :
                    <div className="card"></div>
            }
                
                
                        {showContractPreview ? (
                            <div className="pdfViewer contract-preview-viewer">
                                <div className="contract-preview-toolbar">
                                    <a href={contractPreviewUrl} target="_blank" rel="noopener noreferrer">
                                        Ouvrir le contrat dans un nouvel onglet
                                    </a>
                                </div>
                                {loadingContractPreview && (
                                    <div className="contract-preview-loader" role="status" aria-live="polite">
                                        <i className="pi pi-spin pi-spinner" aria-hidden="true" />
                                        <span>Chargement de l'aperçu...</span>
                                    </div>
                                )}
                                <iframe
                                    className="pdfViewerFrame"
                                    src={contractPreviewUrl}
                                    title="Contrat de location"
                                    onLoad={() => setLoadingContractPreview(false)}
                                >
                                    <p>
                                        Votre navigateur ne peut pas afficher le PDF.{" "}
                                        <a href={rental.pdf} target="_blank" rel="noopener noreferrer">
                                            Télécharger le contrat
                                        </a>
                                        .
                                    </p>
                                </iframe>
                            </div>
                        ) : (
                            <div className="contract-preview-empty">
                            <Button
                                icon="pi pi-file-pdf"
                                label="Afficher l'aperçu"
                                loading={loadingContractPreview}
                                disabled={loadingContractPreview}
                                onClick={showContractPreviewAction}
                                severity="secondary"
                            />
                            </div>
                        )}
               
                

                
            </div>
             )}
            <div id="mainSubContent" >

                <Outlet />
            </div>
    </div>
    );
}
